import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  PLATFORM_ID,
  Self,
  ViewChild,
} from '@angular/core';
import { NgControl, ValidationErrors } from '@angular/forms';
import intlTelInput from 'intl-tel-input';

@Component({
  selector: 'app-telephone-input',
  imports: [],
  templateUrl: './telephone-input.component.html',
  styleUrl: './telephone-input.component.css',
})
export class TelephoneInputComponent implements OnInit, AfterViewInit {
  value: string = '';
  mnumber: string = '';
  userAriaDescribedBy: string = 'Enter your phone number';
  itti: intlTelInput.Plugin | undefined;
  static nextId = 0;

  // controlValueAccessor properties
  onTouched = () => {};
  onChange = (phnNumber: string) => {};

  @ViewChild('phone') phoneInput!: ElementRef;
  @HostBinding() id = `app-tel-input-${TelephoneInputComponent.nextId++}`;
  @Input() disabled: boolean = false;
  @Output() inputEvent: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Inject(PLATFORM_ID) private plateformId: Object
  ) {
    // manually setting the value accessor for the control to this component
    if (this.ngControl != null) this.ngControl.valueAccessor = this;
  }
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.plateformId))
      this.itti = intlTelInput(this.phoneInput.nativeElement, {
        initialCountry: 'IN',
        formatOnDisplay: true,
        autoInsertDialCode: true,
        separateDialCode: true,
        preferredCountries: ['IN'],
        utilsScript:
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
      });
  }

  onInput(event: Event) {
    if (this.itti?.isValidNumber()) {
      this.value = this.itti?.getNumber() || '';
      this.inputEvent.emit(this.itti?.getNumber());
    }
  }
  resetNumber() {
    this.itti?.setNumber('');
    this.mnumber = '';
    this.inputEvent.emit(this.mnumber); // emit empty string
  }

  // validation
  validate(): ValidationErrors | null {
    const validationErrors = this.itti?.getValidationError();
    return !this.itti?.isValidNumber()
      ? { invalidNumber: { reason: validationErrors } }
      : null;
  }
  setupField() {
    // manually registering the validation function to overcome circular dependency for validator
    this.ngControl?.control?.setValidators([this.validate.bind(this)]);
    this.ngControl?.control?.updateValueAndValidity();
  }

  // ControlValueAccessor interface for NgControl
  writeValue(value: string): void {
    if (this.itti) this.itti.setNumber(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
